import { render, staticRenderFns } from "./KararNumarasi.vue?vue&type=template&id=459e7aeb"
import script from "./KararNumarasi.vue?vue&type=script&lang=ts"
export * from "./KararNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports